/*Recurso: Catalogs - Servicio de lectura del API: Maneja los catálogos utilizados
    Tareas:
     Analysis/GetSummarybyUser/es
     Analysis/GetDetailbyUser/es
     Analysis/UpdatebyUser/es
     Analysis/SendbyUser/ 
*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + 'Analysis/';

  //tarea: GetSummaryPxF/es
    const cargaGetSummarybyUser = async (token:any) => {
        //console.log ('***API: ' + API_URL + 'GetSummarybyUser/es',  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetSummarybyUser/es', 'method: post',
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

  //tarea: GetDetailbyUser  
    const cargaGetDetailbyUser  = async (token:any, body:any) => {
        //console.log ('***API: ' + API_URL + 'GetDetailbyUser/es', body,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'GetDetailbyUser/es', body, 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };

  //tarea: UpdatebyUser/es  
    const cargaUpdatebyUser = async (token:any, body:any) => {
        //console.log ('***API: ' + API_URL + 'UpdatebyUser/es', body,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'UpdatebyUser/es', body, 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };  

  //tarea: SendbyUser
    const cargaSendbyUser  = async (token:any, body:any) => {
        //console.log ('***API: ' + API_URL + 'SendbyUser/', body,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'SendbyUser/', body, 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    }; 

const analysisService = {
    cargaGetSummarybyUser: cargaGetSummarybyUser,
    cargaGetDetailbyUser: cargaGetDetailbyUser,
    cargaUpdatebyUser: cargaUpdatebyUser,
    cargaSendbyUser: cargaSendbyUser,
  
};

export default analysisService;
